import en from './en.json'
import it from './it.json'

export const rankingTranslations = {
	en,
	it
} as const
